import React, {Component} from 'react';
import Identification from '../../../Common/Identification';
import {PageContainer, PageTitle} from '../../../Common/PageComponents';
import PageDescription from '../../../Common/PageDescription';

class IpManagementIdentificationPage extends Component {
  render() {
    return (
      <PageContainer>
        <PageTitle title="IP 등록/수정/삭제를 위한 휴대폰 인증" data-qa="usagePageTitle">
          Home &gt; MY PC방 &gt; PC방 관리 &gt; <strong>IP 관리</strong>
        </PageTitle>
        <PageDescription>
          IP 정보 변경을 위해 아이핀 또는 휴대폰 인증을 통해 본인인증을 해주세요.
          <br />
          본인인증은 회원 가입 시 본인과 동일한 명의로 본인인증을 진행해야 합니다.
        </PageDescription>
        <Identification nextUrl="/my-pc-bang/management/ip-management" />
      </PageContainer>
    );
  }
}

export default IpManagementIdentificationPage;
